import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { IBannerData, IConsentLetters, ISurgicalData } from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import { fetchBotulinumToxin, fetchBotulinumToxinBanner, fetchConsentLetters } from "../../api/SurgicalDomainApi";

const BotulinumToxin = () => {
  const { setLoading } = useLoader();
  const [botulinumToxinBanner, setBotulinumToxinBanner] = useState<
    IBannerData[]
  >([]);
  const [botulinumToxinData, setBotulinumToxinData] = useState<
    ISurgicalData[]
  >([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([fetchBotulinumToxinBanner(), fetchBotulinumToxin(), fetchConsentLetters()])
      .then(([botulinumToxinBannerData, botulinumToxinData, consentLettersData]) => {
        setBotulinumToxinBanner(botulinumToxinBannerData);
        setBotulinumToxinData(botulinumToxinData);
        setConsentLetters(consentLettersData);
        // setArchiveVideoData(videoData); 
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={botulinumToxinBanner}
        page={"Botulinum Toxin"}
      />
      <SurgicalDomainsDescription descriptionData={botulinumToxinData} consentLetters={consentLetters} surgicalName='Botulinum_Toxin'/>
    </>
  );
};

export default BotulinumToxin;
